import React from 'react'
import Desktop from './Desktop/index';

const Views = (props) => {
  return (
    <Desktop {...props}/>
  )
}


export default Views;